import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals'; 

@Injectable({
  providedIn: 'root'
})
export class AspAutoscoreService {

   constructor(private http: HttpClient) { }
  getScoreDetails(garageKey: string) {
  return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}/garage/scoreDetail/${garageKey}`);
}

}
